import type { NavigateOptions } from '@tanstack/react-router';

let _navigate: ((opts: NavigateOptions) => unknown) | null = null;

export function setNavigate(fn: (opts: NavigateOptions) => unknown) {
    _navigate = fn;
}

export function rootNavigate(to: NavigateOptions) {
    if (!_navigate) return;
    return _navigate(to);
}
